import React, { useEffect, useState } from "react";
import TimelineDetails from "./TimelineDetails";
import CourseDetails from "./CourseDetails";
import PodcastDetails from "./PodcastDetails";
import Challanges from "./Challanges";
import LiveStreamDetails from "./LiveStreamDetails";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { changeActivityDetailsTab } from "../../../features/slices/studentManagementReducer";

const ActivityDetails = () => {
  const dispatch = useDispatch();
  useEffect(() => {}, []);
  const { activityDetailsTab } = useSelector((state) => {
    return state.student;
  });
  const { timeLine, course, podcast, challenges, liveStream } =
    activityDetailsTab;
  const handleClick = (name) => {
    const data = {
      timeLine: false,
      course: false,
      podcast: false,
      challenges: false,
      liveStream: false,
      [name]: true,
    };
    dispatch(changeActivityDetailsTab(data));
  };

  return (
    <div className="tab-content">
      <div className="tab-pane fade active show" id="ActivityDetails">
        <div className="CommonTabs">
          <ul className="nav nav-pills nav-fill">
            <li className="nav-item">
              <a
                className={`nav-link ${timeLine ? "active" : ""}`}
                onClick={() => handleClick("timeLine")}
              >
                Timeline/Feed Details
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${course ? "active" : ""}`}
                onClick={() => handleClick("course")}
              >
                Course Details
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${podcast ? "active" : ""}`}
                onClick={() => handleClick("podcast")}
              >
                Podcasts Details
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${challenges ? "active" : ""}`}
                onClick={() => handleClick("challenges")}
              >
                Challenges Details
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${liveStream ? "active" : ""}`}
                onClick={() => handleClick("liveStream")}
              >
                Live Stream Details
              </a>
            </li>
          </ul>
        </div>
        {timeLine && <TimelineDetails />}
        {course && <CourseDetails />}
        {podcast && <PodcastDetails />}
        {challenges && <Challanges />}
        {liveStream && <LiveStreamDetails />}
      </div>
    </div>
  );
};

export default ActivityDetails;
